import { render, staticRenderFns } from "./dangerousGoodsBlock.vue?vue&type=template&id=6a0f8131"
import script from "./dangerousGoodsBlock.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports